import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CommissionAdditionalCredit } from 'src/app/model/commission-additional-credit.model';
import { CommissionAdditionalPromotor } from 'src/app/model/commission-additional-promotor.model';
import { CommissionAdjustment } from 'src/app/model/other-catalogs-models';

@Injectable({
  providedIn: 'root'
})
export class CommissionSimulatorService {
  private url:string;
  private url2:string;
  private headers: HttpHeaders = new HttpHeaders({ 
    'Access-Control-Allow-Origin': '*'
    , 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE'
    , 'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers,X-Access-Token,XKey,Authorization'  
  });

  constructor(private http:HttpClient) { 
    this.url=environment.services_url;
    this.url2=environment.promotor_url;
  }

  getCommissionCollect=(createdDateIni:string, createdDateFin:string, commissionGroup:number, simulateId:number)=> {
    return this.http.get(`${this.url}/CommissionCollect/getCommissionCollect?createdDateIni=${createdDateIni}&createdDateFin=${createdDateFin}&commissionGroup=${commissionGroup}&simulateId=${simulateId}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getTaskStatus = (sessionId: string, activeLog: boolean) => {
    return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/findResultCalculoComisiones?sessionId=${sessionId}&activeLog=${activeLog}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getCommissionCollect2=(createdDateIni:string, createdDateFin:string, commissionGroup:number, simulateId:number)=> {
    return this.http.get(`${this.url}/CommissionCollect/getCommissionCollect2?createdDateIni=${createdDateIni}&createdDateFin=${createdDateFin}&commissionGroup=${commissionGroup}&simulateId=${simulateId}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getCommissionCollectResults=(simulateDate:string, commissionGroup:number, simulateId:number, motiveId:number)=> {
    return this.http.get(`${this.url}/CommissionCollect/getCommissionCollectResults?simulateDate=${simulateDate}&commissionGroup=${commissionGroup}&simulateId=${simulateId}&motiveId=${motiveId}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getCommissionCollectResults2=(simulateDate:string, commissionGroup:number, simulateId:number, motiveId:number)=> {
    return this.http.get(`${this.url}/CommissionCollect/getCommissionCollectResults2?simulateDate=${simulateDate}&commissionGroup=${commissionGroup}&simulateId=${simulateId}&motiveId=${motiveId}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getCommissionCollectMotives=(simulateDate:string, commissionGroup:number, simulateId:number)=> {
    return this.http.get(`${this.url}/CommissionCollect/getCommissionCollectMotives?simulateDate=${simulateDate}&commissionGroup=${commissionGroup}&simulateId=${simulateId}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getCommissionCollectSalePromotions=(simulateDate:string, commissionGroup:number, simulateId:number)=> {
    return this.http.get(`${this.url}/CommissionCollect/getCommissionCollectSalePromotions?simulateDate=${simulateDate}&commissionGroup=${commissionGroup}&simulateId=${simulateId}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getCommissionCollectGroupApplied=(simulateDate:string, commissionGroup:number)=> {
    return this.http.get(`${this.url}/CommissionCollect/getCommissionCollectGroupApplied?simulateDate=${simulateDate}&commissionGroup=${commissionGroup}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getCommissionCollectPromotorComplements=(simulateDate:string, commissionGroup:number, simulateId:number)=> {
    return this.http.get(`${this.url}/CommissionCollect/getCommissionCollectPromotorComplements?simulateDate=${simulateDate}&commissionGroup=${commissionGroup}&simulateId=${simulateId}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getCommissionCollectPromotorComplementsApplied=(simulateDate:string, commissionGroup:number)=> {
    return this.http.get(`${this.url}/CommissionCollect/getCommissionCollectPromotorComplementsApplied?simulateDate=${simulateDate}&commissionGroup=${commissionGroup}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  saveCommissionAdjustment=(commissionAdjustment:CommissionAdjustment)=> {
    return this.http.post(`${this.url}/CommissionCollect/saveCommissionAdjustment`, commissionAdjustment)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  saveCommissionCaneAdditionalPromotor=(commissionPromotor:CommissionAdditionalPromotor)=> {
    return this.http.post(`${this.url}/CommissionCollect/saveCommissionCaneAdditionalPromotor`, commissionPromotor)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  saveCommissionCaneAdditionalCredit=(commissionCredit:CommissionAdditionalCredit)=> {
    return this.http.post(`${this.url}/CommissionCollect/saveCommissionCaneAdditionalCredit`, commissionCredit)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  resendCommission(claveEmpleadoDispersion:string): Observable<HttpEvent<any>>  {
    const formData: FormData = new FormData();
    formData.append('claveEmpleadoDispersion', claveEmpleadoDispersion);

    const req = new HttpRequest('POST', `${this.url}/CommissionCane/resendCommission`, formData, {
      reportProgress: true,
      responseType: 'json',
      headers: this.headers
    });

    return this.http.request(req);
  }

  saveCommissionCanePromotorRequest=(simulateDate:string, createUser:string)=> {
    return this.http.get(`${this.url}/CommissionCollect/saveCommissionCanePromotorRequest?simulateDate=${simulateDate}&createUser=${createUser}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  saveCommissionCanePromotorRequest2=(simulateDate:string, createUser:string)=> {
    return this.http.get(`${this.url}/CommissionCollect/saveCommissionCanePromotorRequest2?simulateDate=${simulateDate}&createUser=${createUser}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getInfoPromotor=(idEmpleado:string)=>{
    return this.http.get(`${this.url2}/bimovil/servlet/ActionServletTC?cve=${idEmpleado}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getInfoCredit=(idCredit:number)=>{
    return this.http.get(`${this.url}/CommissionCollect/getInfoByCredit?creditId=${idCredit}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getCommissionCanePromotorRequests=(simulateDate:string)=>{
    return this.http.get(`${this.url}/CommissionCollect/getCommissionCanePromotorRequests?simulateDate=${simulateDate}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getCommissionCollectPromotorDirect=(simulateDate:string,  simulateId:number)=> {
    //return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/CommissionCollectPromotorDirect?simulateDate=${simulateDate}&simulateId=${simulateId}`)
    return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/CommissionCollectPromotorDirect2?simulateDate=${simulateDate}&simulateId=${simulateId}&incluirAntiguos=false`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getCommissionCollectPromotorDirect2=(simulateDate:string,  simulateId:number, incluirAntiguos:boolean)=> {
    //return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/CommissionCollectPromotorDirect?simulateDate=${simulateDate}&simulateId=${simulateId}`)
    return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/CommissionCollectPromotorDirect2?simulateDate=${simulateDate}&simulateId=${simulateId}&incluirAntiguos=${incluirAntiguos}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
}
